import * as React from 'react';
import { IconProps } from '../../dto/Interfaces/IIconProps';

const Deliveroo: React.FC<IconProps> = ({ color, size, style }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      width={size ?? '21'}
      height={size ?? '21'}
      fill="none"
      viewBox="0 0 21 21"
      data-testid="deliveroo-icon"
    >
      <path
        fill={color ?? '#00ccbc'}
        style={{
          stroke: 'none',
          fillRule: 'nonzero',
          fillOpacity: 1,
          strokeWidth: 0.274742,
        }}
        d="m15.143 0-1.077 9.26-1.838-7.807-5.76 1.107 1.837 7.806L0 11.96l1.466 6.237L16.072 21l3.34-6.776L21 .556ZM9.917 11.908a.784.784 0 0 1 .308.057c.198.082.533.254.602.518.098.38.004.7-.298.95-.301.25-.7.227-1.122.1-.422-.127-.61-.588-.45-1.145.12-.414.68-.475.96-.48Zm3.955.48c.427-.011.794.162 1.002.475.208.312.104.655-.115 1-.221.343-.795.389-1.36.139-.381-.169-.379-.598-.337-.86a.778.778 0 0 1 .185-.39c.136-.156.363-.359.625-.365z"
      />
    </svg>
  );
};

export default Deliveroo;
